// extracted by mini-css-extract-plugin
module.exports =  {"logoWrapper":"AssetLogo-module__logoWrapper--O8TUn"};